export const MIN_CROP_ZOOM_LEVEL = 1;
export const MAX_CROP_ZOOM_LEVEL = 5;
export const CROP_ZOOM_STEP = 0.25;
